<template>
    <div ref="fullscreen">
        <show-component :visualization_id="visualization_id"></show-component>
        <div class="footer">
            <b-button @click="toggle" class="pull-right full-screen" variant="default">
                <font-awesome-icon v-if="fullscreen" icon="compress"/>
                <font-awesome-icon v-else icon="expand"/>
            </b-button>
            <a :href="route" v-b-tooltip.hover title="Open Visualization in Data Providers" class="pull-right logo" target="_blank">Data Providers</a>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import ShowComponent from './Show';

    export default {
        name: "Embed",
        props: ['visualization_id'],
        data() {
            return {
                fullscreen: false,
                route: ''
            }
        },
        components: {
            ShowComponent,
        },
        created() {
            this.route = `${this.baseUrl}/#/visualizations/${this.visualization_id}`
        },
        computed: {
            ...mapState({
                baseUrl: state => state.baseUrl,
            })
        },
        methods: {
            toggle () {
                this.$fullscreen.toggle(this.$refs['fullscreen'], {
                    wrap: true,
                    callback: this.fullscreenChange,
                    background: '#FFFFFF'
                })
            },
            fullscreenChange (fullscreen) {
                this.fullscreen = fullscreen
            }
        },
    }
</script>

<style scoped>
    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 22px;
        background-color: #f5f5f5;
    }
    .footer .logo {
        font-family: 'Teko', sans-serif;
        font-size: 18px;
        color: #444;
    }
    .full-screen {
        padding: 0;
        margin-left: 5px;
    }
</style>